import {IRoomRunFile} from '../../incase-domain/proptypes/IRoomRunFile';
import {
    FIND_ROOM_BY_ID,
    IFindRoomByIdAction,
    IUpdateCurrentOwnerSlideAction,
    IUpdateRoomReducerAction,
    IUpdateRoomRunFileAction,
    IUpdateRoomUserCount,
    UPDATE_CURRENT_OWNER_SLIDE,
    UPDATE_ROOM_REDUCER,
    UPDATE_ROOM_RUN_FILE,
    UPDATE_ROOM_USER_COUNT,
} from './types/roomRunFile.actions.types';
import {IFetchRoom} from '../../incase-domain/rooms/room.player';
import {GuestCredentials} from '../../components/presentationView/parts/components/GuestModal';

export const updateRoomUserCount = (userCount: number): IUpdateRoomUserCount => ({
    type: UPDATE_ROOM_USER_COUNT,
    payload: userCount,
});

export const updateRoomRunFileAction = (roomRunFile: IRoomRunFile): IUpdateRoomRunFileAction => ({
    type: UPDATE_ROOM_RUN_FILE,
    roomRunFile,
});

export const findRoomByIdAction = (
    roomId: string,
    credential?: GuestCredentials,
    params?: Record<string, string>,
    hash?: string,
    presenterCode?: string
): IFindRoomByIdAction => ({
    type: FIND_ROOM_BY_ID,
    payload: {roomId, credential, params, hash, presenterCode},
});

export const updateRoomReducerAction = (room: IFetchRoom): IUpdateRoomReducerAction => ({
    type: UPDATE_ROOM_REDUCER,
    room,
});

export const updateCurrentOwnerSlideAction = (slideIndex: number): IUpdateCurrentOwnerSlideAction => ({
    type: UPDATE_CURRENT_OWNER_SLIDE,
    slideIndex,
});
